import type { ProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import createEntry from '../../common/utils/api/index.tsx';
import { props } from './constants.tsx';

export default createEntry<{
	name: string;
	id: string;
	self: string;
	projectKey: ProjectKey;
}>(props);
